import React, { PropTypes } from 'react';
import { TextAreaField } from 'common/components/form_fields';
import { Field } from 'redux-form';

const PositiveFeedback = ({ handleSubmit, onSubmit, onHide, author_username }) => (
  <form className="entry-feedback-form" onSubmit={handleSubmit(onSubmit)}>
    <h3>Anything {author_username} can do to improve it?</h3>
    <Field
      component={TextAreaField}
      name="feedback"
      rows={3}
    />
    <div className="form-actions">
      <button type="submit" className="btn btn-block btn-primary">Send Feedback</button>
      <button type="button" className="btn btn-block btn-text" onClick={onHide}>Cancel</button>
    </div>
  </form>
);

PositiveFeedback.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  author_username: PropTypes.string,
};

export default PositiveFeedback;



// WEBPACK FOOTER //
// ./project/components/entries/positive_feedback.jsx